export enum AppFeatureSwitch {
  Payroll = 46
}

export enum AppPermission {
  BenefitsAccess = 6051,
  MeetingNotesView = 10001,
  MeetingNotesEdit = 10002,
  MeetingNotesMaster = 3212,
  CredentialTransitionsManage = 3148,
  CredentialTransitionsView = 3149,
  CredentialTransitionsEdit = 3150,
  ApproveDocumentUpload = 6100,
  PayrollApprovalApprove = 154,
  PayrollApprovalViewAll = 3022,
  PayrollApprovalShowAllItems = 3069,
  PayrollApprovalViewAssigned = 3120,
  PayrollApprovalEditItems = 3126,
  PayrollApprovalViewMainCampus = 6030,
  HRPortalReimbursementsHRApproval = 12008,
  HRPortalReimbursementsAAInitialApproval = 12009,
  HRPortalReimbursementTypesView = 12010,
  HRPortalReimbursementTypesEdit = 12011,
  LittleTiffUse = 12001
}

export enum BenefitEnrollmentApprovalStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Withdrawn = 4
}
